<script setup lang="ts">
import type { IItemVariantOption, IItemVariantOptionMap } from '@rediredi/types'

const props = defineProps<{
  options: IItemVariantOption[]
  selectedOptions: IItemVariantOptionMap[]
}>()
const emit = defineEmits<{
  (e: 'update:selectedOptions', value: IItemVariantOptionMap[]): void
}>()

const selectedPrimary = ref('')
const selectedSecondary = ref('')

const options = computed(() =>
  props.options.map((option) => ({
    ...option,
    values: option.values.sort((a, b) => {
      if (a.position && b.position) return a.position - b.position

      return a.name.localeCompare(b.name)
    }),
  })),
)

watch([selectedPrimary, selectedSecondary], ([primary, secondary]) => {
  const options: IItemVariantOptionMap[] = []

  if (primary) options.push({ name: props.options[0].name, value: primary })
  if (secondary) options.push({ name: props.options[1].name, value: secondary })

  emit('update:selectedOptions', options)
})

watch(
  () => props.selectedOptions,
  (value) => {
    selectedPrimary.value = value[0]?.value || ''
    selectedSecondary.value = value[1]?.value || ''

    if (props.options[1]) {
      const hasOption = !!props.options[1].values.find(
        ({ name }) => name === selectedSecondary.value,
      )
      if (!hasOption) selectedSecondary.value = props.options[1].values[0].name || ''
    }
  },
  { immediate: true },
)
</script>
<template>
  <div class="flex flex-col gap-5">
    <div v-for="(option, i) in options" :key="option.name">
      <p v-if="option.values.length" class="mb-4 text-sm font-medium text-gray-400">
        {{ option.name }}
      </p>
      <div class="flex flex-wrap items-center gap-3">
        <template v-for="value in option.values" :key="value.name">
          <RProductOption v-if="i === 0" v-model:selected="selectedPrimary" :option-value="value" />
          <RProductOption v-else v-model:selected="selectedSecondary" :option-value="value" />
        </template>
      </div>
    </div>
  </div>
</template>
